export default {
  segment_labels: {
    active: 'Actief',
    cancelled: 'Geannuleerd',
    completed: 'Voltooid',
  },
};
